import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { BOOKING_URL } from "@/data/content";
import { SP_WIDGET_ATTRS } from "./BookingButton";

const links = [
  { href: "#services", label: "Services" },
  { to: "/conditions", label: "Conditions" },
  { href: "#about", label: "About" },
  { to: "/blog", label: "Journal" },
  { href: "#events", label: "Events" },
  { href: "#rental", label: "Space Rental" },
  { href: "#wellness-popup", label: "Corporate Events" },
  { to: "/quizzes", label: "Quizzes" },
  { to: "/circle", label: "Members Only Circle" },
  { href: "#contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const onHome = location.pathname === "/";

  return (
    <header
      className="sticky top-0 z-40 backdrop-blur-md border-b"
      style={{ background: "rgba(249,246,240,0.86)", borderColor: "var(--sano-border)" }}
      data-testid="site-navbar"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 flex items-center justify-between h-20">
        <Link to="/" className="flex items-baseline gap-2" data-testid="nav-logo">
          <span className="font-serif-display text-3xl leading-none">Sano</span>
          <span className="eyebrow hidden sm:inline">Acupuncture · Bronx</span>
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            l.to ? (
              <Link
                key={l.label}
                to={l.to}
                className="text-sm tracking-wide hover:text-[#3A5A40] transition-colors"
                data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              >
                {l.label}
              </Link>
            ) : (
              <a
                key={l.label}
                href={onHome ? l.href : `/${l.href}`}
                className="text-sm tracking-wide hover:text-[#3A5A40] transition-colors"
                data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              >
                {l.label}
              </a>
            )
          ))}
          <a
            href={BOOKING_URL}
            target="_blank"
            rel="noreferrer"
            {...SP_WIDGET_ATTRS}
            className="px-5 py-2.5 rounded-full text-sm font-medium text-[#F9F6F0] transition-all hover:opacity-90"
            style={{ background: "var(--sano-olive)" }}
            data-testid="nav-book-btn"
          >
            Book a session
          </a>
        </nav>

        <button
          className="lg:hidden p-2 -mr-2"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
          data-testid="nav-mobile-toggle"
        >
          {open ? <X size={22} strokeWidth={1.5} /> : <Menu size={22} strokeWidth={1.5} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t" style={{ borderColor: "var(--sano-border)" }}>
          <div className="px-6 py-6 flex flex-col gap-4">
            {links.map((l) => (
              l.to ? (
                <Link
                  key={l.label}
                  to={l.to}
                  onClick={() => setOpen(false)}
                  className="text-base"
                  data-testid={`nav-mobile-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                >
                  {l.label}
                </Link>
              ) : (
                <a
                  key={l.label}
                  href={onHome ? l.href : `/${l.href}`}
                  onClick={() => setOpen(false)}
                  className="text-base"
                  data-testid={`nav-mobile-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                >
                  {l.label}
                </a>
              )
            ))}
            <a
              href={BOOKING_URL}
              target="_blank"
              rel="noreferrer"
              {...SP_WIDGET_ATTRS}
              className="self-start px-5 py-2.5 rounded-full text-sm text-[#F9F6F0]"
              style={{ background: "var(--sano-olive)" }}
              data-testid="nav-mobile-book"
            >
              Book a session
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
